import { render, staticRenderFns } from "./SidebarUserCard.vue?vue&type=template&id=182d0a0e&scoped=true"
import script from "./SidebarUserCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarUserCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarUserCard.vue?vue&type=style&index=0&id=182d0a0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d0a0e",
  null
  
)

export default component.exports